import { useEffect, useRef } from "react";

/**
 * Selects an element based on a selector string and sets it in a ref. Only use
 * this if you can't directly access an element and regular ref doesn't work.
 *
 * @param selector querySelector-compatible selector
 */
export function useQuerySelector<T extends Element>(selector: string) {
  const ref = useRef<T | null>();

  useEffect(() => {
    ref.current = document.querySelector(selector) as T | null;
  }, [selector]);

  return ref;
}
